/* eslint-disable no-await-in-loop */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, {  useState } from 'react';

// components
import HearroResult from './HearroResult';
import HearroMemo from './HearroMemo';
import HearroGame from './HearroGame';


function HearroPatientReport() {
	const reportTag = [
		{ key: 'result', value: '결과보기', component:  <HearroResult /> },
		{ key: 'game', value: '게임별 이력', component: <HearroGame />}
	];

	const [selectedTag, setSelectedTag] = useState("result");

	return (
		<div className="patientManageDetail__report">
			<div className="reportTag">
				{reportTag.map((item) => {
					return (
						<div
							key={item.key}
							className="reportTagItem"
							role="none"
							onClick={() => setSelectedTag(item.key)}
							style={{
								background: selectedTag === item.key ? '#aed0db' : 'white',
								border: selectedTag === item.key ? '0.5px solid transparent' : '0.5px solid #174a84',
							}}
						>
							{item.value}
						</div>
					);
				})}
			</div>
			<div className="reportContent">
			<div className="reportContent__patientResult">
					{reportTag.filter(e=>e.key===selectedTag)[0].component}
					{selectedTag==="result" && <div className='reportContent_sideSection'>
						<HearroMemo />
					</div>}
				</div>	
			</div>
		</div>
	);
}

export default HearroPatientReport;
